module.exports = __webpack_public_path__ + "static/img/logo.763725d5.png";